import React from "react";
import AssortmentManagement from "../components/assortmentManagement/AssortmentManagement";
import Layout from "./Layout.js";

export default function AssortmentView() {
  return (
    <Layout title="Assortimentsbeheer">
      <AssortmentManagement />
    </Layout>
  );
}
